<template>
  <div
    class="formatted-text"
    v-html="field.properties.basic.rawText"
  />
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  field: {
    type: Object,
    required: true
  }
};
export default __sfc_main;
</script>

<style lang="scss">
.formatted-text {
  strong {
    color: inherit;
  }
}
</style>
